import React from "react";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    fontWeight: "bold",
    textTransform: "uppercase",
    fontSize: "1.5em",
    marginTop: "0.83em",
    marginBottom: theme.spacing(2),
    "& .MuiButtonBase-root": {
      paddingLeft: theme.spacing(1),
    },
    "& h2": {
      textTransform: "uppercase",
      marginBottom: 0,
      marginTop: 0,
      textAlign: "center",
    },
    "& h3": {
      textTransform: "none",
      marginTop: 0,
      marginBottom: 0,
      textAlign: "center",
      fontWeight: "normal",
    },
  },
  textContainer: {
    position: "relative",
    marginRight: "auto",
    marginLeft: "auto",
    textAlign: "center",
    fontSize: "16px",
    "&.with-icon": {
      left: "-22px",
    },
  },
}));

export default ({ title, subtitle, onClick, children }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {onClick && (
        <IconButton onClick={onClick}>
          <Icon>arrow_back</Icon>
        </IconButton>
      )}
      <span
        className={`${classes.textContainer} ${onClick ? "with-icon" : ""}`}
      >
        {title && <h2>{title}</h2>}
        {subtitle && <h3>{subtitle}</h3>}
        {!title && <span>{children}</span>}
      </span>
    </div>
  );
};
